import { Link } from "@/components/Link";
import { UserAvatar } from "@/components/UserAvatar";
import { format } from "@/lib/utils";
import type { User } from "../../types";
import { usePersistedAdminGridOptions } from "../../utils/gridState";
import { AdminGrid } from "../AdminGrid";
import { TableFilterRow } from "../TableFilterRow";

export function UsersTable({ users }: { users: User[] | undefined }) {
  const { options, filterTextProps } = usePersistedAdminGridOptions(
    "users",
    users,
    [
      {
        field: "username",
        cellRenderer: (params) => (
          <div className="flex items-center gap-2">
            <UserAvatar user={params.user} />
            <Link
              to="/admin/users/$id/edit"
              params={{ id: params.id }}
              className="block truncate"
            >
              {params.username}
            </Link>
          </div>
        ),
        cellRendererParams: (params) => ({
          id: params.data.id,
          username: params.data.username,
          user: params.data,
        }),
      },
      { field: "email" },
      {
        field: "org.name",
        headerName: "Client",
        filter: "agSetColumnFilter",
        cellRenderer: (params) => (
          <Link to="/admin/clients/$id/edit" params={{ id: params.id }}>
            {params.name}
          </Link>
        ),
        cellRendererParams: (params) => ({
          id: params.data.org.id,
          name: params.data.org.name,
        }),
      },
      {
        field: "defaultRole",
        headerName: "Role",
        filter: "agSetColumnFilter",
        valueGetter: (params) =>
          params.data?.overrides?.role ?? params.data?.defaultRole,
      },
      {
        field: "lastLogin",
        cellDataType: "date",
        initialSort: "desc",
        valueFormatter: ({ value }) => format(value),
      },
    ],
  );

  return (
    <>
      <TableFilterRow inputProps={filterTextProps} />
      <AdminGrid {...options} />
    </>
  );
}
